<template>
    <div v-if="hasVideoError">
        <p>{{ cameraMsg }}</p>
        <vs-button icon-pack="feather" icon="icon-rotate-cw" color="rgb(255, 255, 255)" type="line" size="small"
            @click="connect">{{ retryText }}</vs-button>
    </div>
</template>

<script>
export default {
    name: "CameraLoader",
    props: {
        hasVideoError: Boolean,
        cameraMsg: String,
        retryText: String,
        connect: Function
    }
};
</script>